import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../contexts/WalletContext';
import { useNetwork } from '../contexts/NetworkContext';
import { useGovernance } from '../contexts/GovernanceContext';
import jazzicon from '@metamask/jazzicon';
import ThemeToggle from './ThemeToggle';
import NetworkSelector from './NetworkSelector';
import './Header.css';

interface HeaderProps {
  subtitle?: string;
}

const Header: React.FC<HeaderProps> = ({ subtitle }) => {
  const navigate = useNavigate();
  const { isConnected, account, connectWallet, disconnectWallet, error, loading, signer } = useWallet();
  const { currentNetwork } = useNetwork();
  const { contractAddress, clearContractAddress } = useGovernance();
  const iconRef = useRef<HTMLDivElement>(null);

  const handleWalletAction = () => {
    if (isConnected) {
      disconnectWallet();
      // Redirect to homepage after disconnecting
      navigate('/');
    } else {
      connectWallet();
    }
  };

  const handleSwitchContract = () => {
    clearContractAddress();
    navigate('/');
  };

  useEffect(() => {
    if (account && iconRef.current) {
      // Clear previous icon
      iconRef.current.innerHTML = '';
      // Generate new jazzicon
      const icon = jazzicon(24, parseInt(account.slice(2, 10), 16));
      iconRef.current.appendChild(icon);
    }
  }, [account]);

  return (
    <header>
      <div className="header-content">
        <div className="header-left">
          <h1>
            trustline{subtitle && ` - ${subtitle}`}
          </h1>
        </div>
        <div className="wallet-section">
          {isConnected ? (
            <div className="wallet-info">
              {contractAddress && (
                <div className="contract-info">
                  <span className="contract-label">Governance:</span>
                  <span className="contract-address">{contractAddress.slice(0, 6)}...{contractAddress.slice(-4)}</span>
                  <button onClick={handleSwitchContract} className="switch-escrow-btn" title="Switch to another governance contract">
                    ↻
                  </button>
                </div>
              )}
              <div className="account-display">
                <div ref={iconRef} className="account-icon"></div>
                <span className="account">{account.slice(0, 6)}...{account.slice(-4)}</span>
              </div>
              {signer && currentNetwork && (
                <NetworkSelector />
              )}
              <button onClick={handleWalletAction} className="wallet-btn disconnect">
                Disconnect
              </button>
            </div>
          ) : (
            <button 
              onClick={handleWalletAction} 
              className="wallet-btn connect"
              disabled={loading}
            >
              {loading ? 'Connecting...' : 'Connect Wallet'}
            </button>
          )}
          <ThemeToggle />
        </div>
      </div>
      {error && (
        <div className="header-error">
          {error}
        </div>
      )}
    </header>
  );
};

export default Header;
